import React from 'react';
import styled from 'styled-components';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const Spinner = ({
  className = '',
  width = '35px',
  height = '35px',
}: Props) => {
  return (
    <StyledSpinner
      data-testid="spinner-icon"
      className={`${className} spinner-icon`}
      width={width}
      height={height}
      viewBox="0 0 56 56"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="loader-circle loader-circle-dark-green"
        cx="28"
        cy="28"
        r="25"
      />
      <circle
        className="loader-circle loader-circle-light-green"
        cx="28"
        cy="28"
        r="25"
        transform="rotate(-140.4 28 28)"
      />
      <circle
        className="loader-circle loader-circle-yellow"
        cx="28"
        cy="28"
        r="25"
        transform="rotate(-108 28 28)"
      />
    </StyledSpinner>
  );
};

export default Spinner;

const StyledSpinner = styled.svg`
  fill: none;
  height: 100%;
  stroke-linecap: round;
  stroke-width: 6;
  width: 100%;

  @keyframes yellow-circle {
    0% {
      stroke-dashoffset: 141.3;
      transform: rotateZ(-108deg);
    }

    50% {
      stroke-dashoffset: 113.04;
      transform: rotateZ(39.6deg);
    }

    100% {
      stroke-dashoffset: 141.3;
      transform: rotateZ(252deg);
    }
  }

  @keyframes light-green-circle {
    0% {
      stroke-dashoffset: 113.04;
      transform: rotateZ(-140.4deg);
    }

    50% {
      stroke-dashoffset: 51.81;
      transform: rotateZ(1.8deg);
    }

    100% {
      stroke-dashoffset: 113.04;
      transform: rotateZ(219.6deg);
    }
  }

  .loader-circle {
    stroke-dasharray: 157;
    transform-origin: center;
  }

  .loader-circle-yellow {
    animation: yellow-circle 1s linear infinite;
    stroke: #ffd200;
    stroke-dashoffset: 141.3;
    transform: rotateZ(-108deg);
  }

  .loader-circle-light-green {
    animation: light-green-circle 1s linear infinite;
    stroke: #86d1cd;
    stroke-dashoffset: 113.04;
    transform: rotateZ(-140.4deg);
  }

  .loader-circle-dark-green {
    stroke: #37aba1;
  }
`;
